import { ActionIcon, Autocomplete, Box, Drawer, Flex, Group, Image, Input, Loader, Rating, Text } from '@mantine/core';
import { forwardRef, useEffect, useRef, useState } from 'react';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from '../config/RoutesName';
import { useDisclosure } from '@mantine/hooks';
import GlobalSearch from './GlobalSearch';
import { searchStyle } from './ComponentStyle';
import { useRestuarentList } from '../services/restuarent.service';
import { useRestaurantMenuItem } from '../services/menuItem.service';
import { DummyImage, locationIcon, scanIcon, searchIcon } from '../assets';
interface SearchProps {
  searchInput: (arg: object) => void;
  searchResult?: [];
  searchComponent?: boolean;
}
interface ItemProps {
  name?: string;
  address: string;
  image_url?: string;
  rating?: any;
  city?: string;
}

const SearchScan = ({ searchInput, searchComponent }: SearchProps) => {
  const { classes } = searchStyle();
  // const { inputValue, setInputValue } = useContext(BookingContext);
  const [inputValue, setInputValue] = useState('');
  const [opened, { open, close }] = useDisclosure(false);
  const navigate = useNavigate();
  const inputRef = useRef(null);
  const [searchResult, setSearchResult] = useState([]);
  const [itemsPerPage, setItemPerPage] = useState(0);
  const { detailId } = useParams();
  const { data: restaurantName, isLoading } = !detailId
    ? useRestuarentList(null, 10, inputValue)
    : { data: null, isLoading: false };
  const { data: menuItemName, isLoading: menuItemLoading } = detailId
    ? useRestaurantMenuItem(detailId, null, 10, inputValue)
    : { data: null, isLoading: false };

  useEffect(() => {
    if (!isLoading && restaurantName) {
      restaurantName.pages.map((item: any) => {
        setSearchResult(item.data), setItemPerPage(item.items_per_page);
      });
    } else if (detailId && menuItemName && !menuItemLoading) {
      menuItemName.pages.map((item: any) => {
        setSearchResult(item.data), setItemPerPage(item.items_per_page);
      });
    }
  }, [restaurantName, menuItemName]);

  const AutoCompleteItem = forwardRef<HTMLDivElement, ItemProps>((props: ItemProps, ref) => {
    const { ...rest } = props;
    return (
      <>
        <Box fw={500} ta={'left'} ref={ref} {...rest} p='sm' classNames={[classes.dropdownList]}>
          {detailId ? (
            <Text fz={'12px'} color='black'>
              {props.name}
            </Text>
          ) : (
            <Flex>
              <Box mr='xs'>
                <Image src={props.image_url || DummyImage} radius={12} height={'70px'} width={'70px'} mih='100%' />
              </Box>
              <Flex direction={'column'} gap={5}>
                <Text fz={'12px'} color='black'>
                  {props.name}
                </Text>
                <Flex>
                  <Rating size={'sm'} value={props.rating.average_rating} readOnly />
                  <Text pl={'5px'} fw={'bold'} color='black'>
                    ({props.rating.count})
                  </Text>
                </Flex>
                <Group>
                  <Flex gap={3}>
                    <Image pt={2} width='auto' height='auto' src={locationIcon} />
                    <Text variant='outline' ta='left' lineClamp={1}>
                      1.5 mile
                    </Text>
                  </Flex>
                  |
                  <Text variant='outline' ta='left' lineClamp={1}>
                    {props.city}
                  </Text>
                </Group>
              </Flex>
            </Flex>
          )}
        </Box>
      </>
    );
  });

  return (
    <>
      <Flex pb={25}>
        <Flex direction='column' w='100%' align='left'>
          {searchComponent ? (
            <Autocomplete
              autoFocus={detailId ? false : true}
              placeholder='Search ...'
              type='text'
              data={searchResult}
              limit={itemsPerPage}
              ref={inputRef}
              onChange={(value: string) => {
                setInputValue(value);
              }}
              radius={20}
              maxDropdownHeight={490}
              rightSection={
                <div
                  onClick={() => {
                    if (inputRef.current) {
                      (inputRef.current as HTMLInputElement).focus();
                    }
                  }}>
                  {!isLoading && !menuItemLoading ? (
                    <Image width='18px' pr={'md'} radius={20} display='block' height='20px' mr={12} src={searchIcon} />
                  ) : (
                    <Loader
                      size='sm'
                      style={{
                        position: 'absolute',
                        right: '15px',
                        top: '18px',
                      }}
                    />
                  )}
                </div>
              }
              itemComponent={AutoCompleteItem}
              filter={() => true}
              maw={1020}
              value={inputValue}
              onItemSubmit={(item) => {
                if (detailId) {
                  navigate({
                    // pathname: routesName.AddItem,
                    search: `?menuItemId=${item.menu_item_id}`,
                  });
                } else {
                  searchInput(item);
                }
              }}
              nothingFound='No data found'
            />
          ) : (
            <Input
              placeholder='Search...'
              className={classes.searchItem}
              size='xl'
              radius={20}
              onClick={open}
              readOnly={true}
              rightSection={
                <div>
                  <Image width='18px' pr={'md'} radius={20} display='block' height='20px' mr={18} src={searchIcon} />
                </div>
              }
            />
          )}
        </Flex>

        {!searchComponent && (
          <Flex direction='column' align='right' pl='5px'>
            <NavLink to={`${ROUTES.SCAN}`} style={{ textDecoration: 'none', color: 'black' }}>
              <ActionIcon size={60} className={classes.scanItem}>
                <Image width='auto' height='auto' src={scanIcon} />
              </ActionIcon>
            </NavLink>
          </Flex>
        )}
      </Flex>

      <Drawer
        opened={opened}
        position='top'
        onClose={close}
        withCloseButton={false}
        trapFocus={false}
        returnFocus={false}
        size={'xl'}>
        <GlobalSearch close={close} />
      </Drawer>
    </>
  );
};

export default SearchScan;
